import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";

import { Protected } from "@dzambalaorg/common-pages";
import { IndexWrapper, MarketplaceSection, MarketplaceChart, MarketplaceReport, ServiceType } from "@framework/shared";

import { MarketplaceDiscrete } from "./discrete";

export const marketRoutes: Array<RouteObject> = [
  {
    path: "/marketplace",
    element: <Protected />,
    children: [
      {
        index: true,
        element: <Navigate to="/marketplace/report" />,
      },
      {
        path: "/marketplace/report",
        children: [
          {
            index: true,
            element: (
              <IndexWrapper index="marketplace">
                <MarketplaceSection service={ServiceType.OFFICE} />
              </IndexWrapper>
            ),
          },
          { path: "/marketplace/report/search", element: <MarketplaceReport service={ServiceType.OFFICE} /> },
          { path: "/marketplace/report/chart", element: <MarketplaceChart service={ServiceType.OFFICE} /> },
          { path: "/marketplace/report/discrete", element: <MarketplaceDiscrete /> },
        ],
      },
    ],
  },
];
